import { apiFetch } from "../http";
export function getAdminPurchases(params) {
    const query = new URLSearchParams({
        page: String(params.page || 1),
        page_size: String(params.pageSize || 25),
    });
    if (params.search)
        query.set("search", params.search);
    if (params.status)
        query.set("status", params.status);
    return apiFetch(`/api/billing/admin/purchases/?${query.toString()}`, {
        baseUrl: params.baseUrl,
        token: params.token,
    });
}
export function retryAdminPurchase(params) {
    return apiFetch(`/api/billing/admin/purchases/${encodeURIComponent(params.orderId)}/retry/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params.travelPlanId ? { travel_plan_id: params.travelPlanId } : {}),
    });
}
export function refundAdminPurchase(params) {
    return apiFetch(`/api/billing/admin/purchases/${encodeURIComponent(params.orderId)}/refund/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount_minor: params.amountMinor }),
    });
}
